import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import ProfileHeader from '../../../components/ProfileHeader'
import ProfileBottomNav from '../../../components/ProfileBottomNav'
import {
  DataGridPremium,
  esES,
  GridColDef,
  GridRenderCellParams,
} from '@asf-libs/x-data-grid-premium'
import { useNavigate, useParams } from 'react-router-dom'
import moment from 'moment'
import IconButton from '@mui/material/IconButton'

import Stack from '@mui/material/Stack'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { getUnitChecklist, printChecklist } from '../../../api/ChecklistApi'
import { PrintOutlined } from '@mui/icons-material'
import {getClassStatus} from "../../../utils/generalUtils";

export default function ChecklistList() {
  const { id, domain } = useParams()
  const navigate = useNavigate()

  const getColumns = () => {
    let columns: GridColDef[] = [
      {
        field: 'name',
        headerName: 'Tipo',
        width: 300,
        align: 'left',
      },
      {
        field: 'creationDate',
        headerName: 'Fecha',
        width: 100,
        align: 'left',
      },
      {
        field: 'status',
        headerName: 'Estado',
        width: 150,
        align: 'left',
        renderCell: (params: GridRenderCellParams<any>) => {
          return (<span className={`status-box ${getClassStatus(params.row?.status)}`}>{params.row?.status}</span>)
        }
      },
      {
        field: 'edit',
        headerName: '',
        width: 40,
        renderCell: (params: GridRenderCellParams<any>) => {
          if (params.row.status === 'FINALIZADO') {
            return (
              <strong>
                <IconButton
                  className="primary text"
                  size="small"
                  tabIndex={params.hasFocus ? 0 : -1}
                  onClick={() => handlePrint(params.row.id)}
                >
                  <PrintOutlined />
                </IconButton>
              </strong>
            )
          }
        },
      },
    ]

    return columns
  }

  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    if (id) {
      getUnitChecklist(id)
        .then((response) => {
          const dataRows = response?.data?.map((d: any, index: number) => {
            return {
              id: d.id,
              numberPlate: d?.unit?.numberPlate,
              name: d?.template?.name,
              status: d?.status,
              creationDate: moment(d?.creationDate).format('DD-MM-YYYY'),
            }
          })
          setRows(dataRows ? dataRows : [])
          setLoading(false)
        })
        .catch((e) => {
          setLoading(false)
          console.log('Error', e)
        })
    } else {
      setLoading(false)
      navigate(-1)
    }
  }, [id])

  const handlePrint = (idCheck: any) => {
    if (idCheck) {
      printChecklist(idCheck)
        .then()
        .catch((e) => {
          console.log('Error', e)
        })
    }
  }

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <Box sx={{ background: '#F2F3F1' }}>
      <ProfileHeader></ProfileHeader>
      <Box sx={{ margin: '0 4%' }}>
        <Stack
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          spacing={2}
          mt={2}
        >
          <Box flexGrow="1">
            <h3>
              <IconButton color="primary" onClick={handleBack}>
                <ArrowBackIcon />
              </IconButton>{' '}
              Volver
            </h3>
          </Box>
          <Box flexGrow="1" textAlign="left">
            <Box className="section-title">{domain?.toUpperCase()}</Box>
          </Box>
        </Stack>

        <Box
          sx={{
            typography: 'body1',
            borderRadius: '16px',
            background: '#ffffff',
          }}
        >
          <div style={{ maxHeight: '60vh', overflow: 'auto' }}>
            <div style={{ width: '100%', height: '100%' }}>
              <div style={{ flexGrow: 1 }}>
                <DataGridPremium
                  localeText={
                    esES.components.MuiDataGrid.defaultProps.localeText
                  }
                  rows={rows}
                  autoHeight={true}
                  columns={getColumns()}
                  density="compact"
                  sx={{
                    border: 0,
                    '& .super-app-theme--header': {
                      fontWeight: '900',
                    },
                  }}
                  isRowSelectable={() => false}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </Box>
      </Box>
      <ProfileBottomNav />
    </Box>
  )
}
